import { http } from "../../utils/config";

const departmentAPI = {
  // Get departments with pagination/search
  getDepartments: (params = {}) => {
    return http.get("/api/v1/departments", { params });
  },

  // Get all active departments for selects/lookups
  getAllDepartments: (params = {}) => {
    return http.get("/api/v1/departments/all", { params });
  },

  // Get department by ID
  getDepartmentById: (id) => {
    return http.get(`/api/v1/departments/${id}`);
  },

  // Store new department
  storeDepartment: (data) => {
    return http.post("/api/v1/departments", data);
  },

  // Update existing department
  updateDepartment: (id, data) => {
    return http.put(`/api/v1/departments/${id}`, data);
  },

  // Delete department
  deleteDepartment: (id) => {
    return http.delete(`/api/v1/departments/${id}`);
  },

  // Restore deleted department
  restoreDepartment: (id) => {
    return http.patch(`/api/v1/departments/${id}/restore`);
  },

  // Toggle active status
  toggleStatusDepartment: (id) => {
    return http.patch(`/api/v1/departments/${id}/toggle-status`);
  },
};

// Helper functions for handling API responses
export const departmentHelpers = {
  // Extract data from API response
  extractDepartmentData: (response) => {
    if (response.data && response.data.success) {
      return response.data.data;
    }
    throw new Error(response.data?.message || 'Unknown error occurred');
  },

  // Extract paginated list from API response
  extractDepartmentList: (response) => {
    if (response.data && response.data.success) {
      const data = response.data.data;
      return {
        departments: data.data || [],
        pagination: {
          current: data.current_page,
          pageSize: data.per_page,
          total: data.total,
          from: data.from,
          to: data.to,
          lastPage: data.last_page,
        }
      };
    }
    throw new Error(response.data?.message || 'Unknown error occurred');
  }
};

// Standard error handling wrapper
export const withErrorHandling = (apiFunction) => {
  return async (...args) => {
    try {
      const response = await apiFunction(...args);
      return response;
    } catch (error) {
      console.error('API Error:', error);
      if (error.response) {
        const { status, data } = error.response;
        switch (status) {
          case 400: throw new Error(data.message || 'Dữ liệu không hợp lệ');
          case 401: throw new Error('Bạn cần đăng nhập để thực hiện thao tác này');
          case 403: throw new Error('Bạn không có quyền thực hiện thao tác này');
          case 404: throw new Error('Không tìm thấy dữ liệu yêu cầu');
          case 422: throw new Error(data.message || 'Dữ liệu không hợp lệ');
          case 500: throw new Error(data.message || "Lỗi server, vui lòng thử lại sau");
          default: throw new Error(data.message || 'Đã có lỗi xảy ra');
        }
      } else if (error.request) {
        throw new Error('Không thể kết nối đến server');
      } else {
        throw new Error(error.message || 'Đã có lỗi xảy ra');
      }
    }
  };
};

export const departmentAPIWithErrorHandling = {
  getDepartments: withErrorHandling(departmentAPI.getDepartments),
  getAllDepartments: withErrorHandling(departmentAPI.getAllDepartments),
  getDepartmentById: withErrorHandling(departmentAPI.getDepartmentById),
  storeDepartment: withErrorHandling(departmentAPI.storeDepartment),
  updateDepartment: withErrorHandling(departmentAPI.updateDepartment),
  deleteDepartment: withErrorHandling(departmentAPI.deleteDepartment),
  restoreDepartment: withErrorHandling(departmentAPI.restoreDepartment),
  toggleStatusDepartment: withErrorHandling(departmentAPI.toggleStatusDepartment),
};

export default departmentAPI;
